/* Brand story hydration: replaces the PDP fallback copy with the live entry
   from the public brand dictionary (Supabase app_brand_metadata), matched by
   vendor name exactly the way the app does (lib/brandCatalogue.js): normalise
   to lowercase alphanumerics and compare against the canonical name, display
   name, and known vendor aliases. Below-the-fold content, so this fetch never
   affects first paint. Directory response is cached per session. */

(function () {
  var CACHE_KEY = 'gettmi:brand-directory:v1';

  function normalizeBrandKey(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function config() {
    var el = document.querySelector('[data-gettmi-supabase]');
    return el ? { url: el.dataset.supabaseUrl, key: el.dataset.supabaseKey } : null;
  }

  function fetchDirectory() {
    try {
      var cached = window.sessionStorage.getItem(CACHE_KEY);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) { /* fall through to network */ }

    var cfg = config();
    if (!cfg || !cfg.url || !cfg.key) return Promise.resolve(null);

    var endpoint = cfg.url +
      '/rest/v1/app_brand_metadata?select=canonical_vendor,display_name,shopify_vendors,brand_copy';
    return window.fetch(endpoint, {
      headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (rows) {
      if (rows) {
        try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(rows)); } catch (e) { /* ignore */ }
      }
      return rows;
    }).catch(function () { return null; });
  }

  function findEntry(rows, vendor) {
    var target = normalizeBrandKey(vendor);
    if (!target || !rows) return null;
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i];
      var names = [row.canonical_vendor, row.display_name].concat(row.shopify_vendors || []);
      for (var j = 0; j < names.length; j += 1) {
        if (normalizeBrandKey(names[j]) === target) return row;
      }
    }
    return null;
  }

  function hydrate() {
    var mounts = document.querySelectorAll('[data-gettmi-brand-story]');
    if (!mounts.length) return;
    fetchDirectory().then(function (rows) {
      if (!rows) return;
      mounts.forEach(function (mount) {
        var entry = findEntry(rows, mount.dataset.vendor);
        if (entry && entry.brand_copy) {
          var copy = mount.querySelector('[data-gettmi-brand-copy]');
          if (copy) copy.textContent = entry.brand_copy;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
